import { QuoteData } from './QuoteForm';

export async function generateQuotationPDF(data: QuoteData) {
  // Try dynamic import first (preferred in CRA)
  let jsPDFCtor: any | null = null;
  let autoTableFn: any | null = null;
  try {
    const mod = await import('jspdf');
    // @ts-ignore jsPDF named export
    jsPDFCtor = (mod as any).jsPDF || (mod as any).default || (mod as any);
    try {
      const at = await import('jspdf-autotable');
      // Some builds export default, others attach to jsPDF; keep both
      autoTableFn = (at as any).default || (at as any);
    } catch {}
  } catch {
    // Fallback to globals (when using CDN scripts)
    const jspdfNS: any = (window as any).jspdf || (window as any);
    jsPDFCtor = jspdfNS.jsPDF || jspdfNS.JSPDF || jspdfNS.jsPDF || null;
    autoTableFn = (jspdfNS as any).autoTable || (window as any).autoTable || null;
  }

  if (!jsPDFCtor) {
    alert('jsPDF no estÃ¡ disponible. Instala jspdf y jspdf-autotable o agrega los scripts CDN.');
    return;
  }

  const doc = new jsPDFCtor({ unit: 'pt', format: 'a4' });

  // Branding Royal Trucking
  const margin = 40;
  const pageW = doc.internal.pageSize.getWidth();
  const pageH0 = doc.internal.pageSize.getHeight();
  let y = margin;

  // Marca de agua (centrada, baja opacidad)
  try {
    const wmResp = await fetch('/aguacoti.png');
    if (wmResp.ok) {
      const blob = await wmResp.blob();
      const reader = new FileReader();
      const url = await new Promise<string>(res => { reader.onload = () => res(String(reader.result)); reader.readAsDataURL(blob); });
      const wmW = pageW * 0.75; // ancho relativo
      const wmH = wmW * 0.95;  // relación aproximada del logo
      const x = (pageW - wmW) / 2;
      const yW = (pageH0 - wmH) / 3;
      const GStateCtor = (doc as any).GState;
      const setGState = (doc as any).setGState as ((gs: any) => void) | undefined;
      if (GStateCtor && setGState) {
        setGState(new GStateCtor({ opacity: 0.10 }));
        doc.addImage(url, 'WEBP', x, yW, wmW, wmH);
        setGState(new GStateCtor({ opacity: 1 }));
      } else {
        // Fallback: sin API de opacidad, igualmente dibujar más pequeño
        doc.addImage(url, 'WEBP', x, yW, wmW, wmH);
      }
    }
  } catch {}

  // Logo si existiera en public
  try {
    const logoResp = await fetch('/logopdf.png');
    if (logoResp.ok) {
      const blob = await logoResp.blob();
      const reader = new FileReader();
      const url = await new Promise<string>(res => { reader.onload = () => res(String(reader.result)); reader.readAsDataURL(blob); });
      // Logo mÃ¡s ancho
      doc.addImage(url, 'PNG', margin, y - 6, 200, 50);
    }
  } catch {}

  // Encabezado derecho con datos de empresa
  doc.setFontSize(10); doc.setTextColor(60);
  const lines = [
    'ROYAL TRUKING E.I.R.L.',
    'RUC: 20611798572',
    '',
    '',
    '',
  ];
  lines.forEach((t, i) => {
    doc.text(t, pageW - margin - doc.getTextWidth(t), y + i * 14);
  });

  y += 54;
  // Cabecera tipo tarjeta con dos columnas y badge NÂ° COTIZACIÃ“N
  const boxTop = y - 6;
  const boxLeft = margin;
  const boxWidth = pageW - margin * 2;
  const boxHeight = 120;
  // Caja principal
  doc.setDrawColor(180); doc.setLineWidth(1);
  doc.roundedRect(boxLeft, boxTop, boxWidth, boxHeight, 4, 4);

  // Badge NÂ° CotizaciÃ³n
  const badgeW = 115, badgeH = 28;
  const badgeX = boxLeft + boxWidth - badgeW; // pegado al borde derecho de la caja
  const badgeY = boxTop - 30; // por encima de la caja para no tapar texto
  doc.setFillColor(15, 76, 129); // azul oscuro
  doc.roundedRect(badgeX, badgeY, badgeW, badgeH, 6, 6, 'F');
  doc.setTextColor(255); doc.setFontSize(9); doc.setFont(undefined, 'bold');
  doc.text('N° Cotización', badgeX + 10, badgeY + 12);
  doc.setFontSize(12); doc.setFont(undefined, 'bold');
  const nStr = data.quotationNumber || '-';
  doc.text(nStr, badgeX + badgeW - 8 - doc.getTextWidth(nStr), badgeY + 22);

  // Contenido de la caja
  const leftX = boxLeft + 12; const rightX = boxLeft + boxWidth / 2 + 12;
  const colW = boxWidth / 2 - 4; // ancho por columna dentro de la caja
  const rowY = (row: number) => boxTop + 18 + row * 16;
  doc.setFontSize(10); doc.setTextColor(30); doc.setFont(undefined, 'normal');
  // Columna izquierda (datos cliente)
  const bold = (t: string) => { doc.setFont(undefined, 'bold'); doc.text(t, leftX, 0); };
  doc.setFont(undefined, 'bold'); doc.text('Cotizado a :', leftX, rowY(0)); doc.setFont(undefined, 'normal'); doc.text((data.clientName || '').toUpperCase(), leftX + 78, rowY(0));
  doc.setFont(undefined, 'bold'); doc.text('Atención   :', leftX, rowY(1)); doc.setFont(undefined, 'normal'); doc.text((data.clientContact || '').toUpperCase(), leftX + 78, rowY(1));
  doc.setFont(undefined, 'bold'); doc.text('Correo     :', leftX, rowY(2)); doc.setFont(undefined, 'normal'); doc.text((data.clientEmail || ''), leftX + 78, rowY(2));
  doc.setFont(undefined, 'bold'); doc.text('Teléfonos  :', leftX, rowY(3)); doc.setFont(undefined, 'normal'); doc.text((data.clientPhone || ''), leftX + 78, rowY(3));
  // Datos del asesor
  doc.setFont(undefined, 'bold'); doc.text('Asesor     :', leftX, rowY(4));
  doc.setFont(undefined, 'normal'); doc.text('Juan Terrones', leftX + 78, rowY(4));
  doc.setFont(undefined, 'bold'); doc.text('Correo     :', leftX, rowY(5));
  doc.setFont(undefined, 'normal'); doc.text('juterrones@royal-trucking.com', leftX + 78, rowY(5));
  doc.setFont(undefined, 'bold'); doc.text('Tel.       :', leftX, rowY(6));
  doc.setFont(undefined, 'normal'); doc.text('+51 904 601 791', leftX + 78, rowY(6));
  const wrap = (txt: string, maxW: number) => doc.splitTextToSize(txt, maxW);
  let ry = rowY(0);
  doc.setFont(undefined, 'bold'); doc.text('R.U.C. :', rightX, ry); doc.setFont(undefined, 'normal'); doc.text('20611798572', rightX + 60, ry); ry += 16;
  doc.setFont(undefined, 'bold'); doc.text('Fecha :', rightX, ry); doc.setFont(undefined, 'normal'); doc.text(new Date(data.date).toLocaleDateString('es-PE'), rightX + 60, ry); ry += 16;
  doc.setFont(undefined, 'bold'); doc.text('Validez de la oferta', rightX, ry); doc.setFont(undefined, 'normal'); doc.text(`${data.validityDays ?? 0} Días`, rightX + 140, ry); ry += 16;
  // Condiciones de pago (mÃ¡s pequeÃ±o)
  doc.setFont(undefined, 'bold'); doc.text('Condiciones de pago', rightX, ry);
  doc.setFont(undefined, 'normal'); {
    const prevSize = doc.getFontSize();
    doc.setFontSize(8);
    const lines = wrap(`${(data.paymentTerms || '').toUpperCase()}`, colW - 140);
    doc.text(lines, rightX + 140, ry);
    const cnt = Math.max(1, (Array.isArray(lines) ? lines.length : 1));
    ry += 9 * cnt;
    doc.setFontSize(prevSize);
    doc.setLineHeightFactor(1.1);
  }
  // Disponibilidad (mÃ¡s pequeÃ±o)
  doc.setFont(undefined, 'bold'); doc.text('Disponibilidad', rightX, ry);
  doc.setFont(undefined, 'normal'); {
    const prevSize = doc.getFontSize();
    doc.setFontSize(8);
    const lines = wrap(`${(data.availability || '').toUpperCase()}`, colW - 160);
    doc.text(lines, rightX + 140, ry);
    const cnt = Math.max(1, (Array.isArray(lines) ? lines.length : 1));
    ry += 11 * cnt;
    doc.setFontSize(prevSize);
    doc.setLineHeightFactor(1.1);
  }
  // Carga y Descarga (mÃ¡s pequeÃ±o)
  doc.setFont(undefined, 'bold'); doc.text('No Incluye', rightX, ry);
  doc.setFont(undefined, 'normal'); {
    const prevSize = doc.getFontSize();
    doc.setFontSize(8);
    const lines = wrap(`${(data.loadType || 'No incluye').toUpperCase()}`, colW - 160);
    doc.text(lines, rightX + 140, ry);
    const cnt = Math.max(1, (Array.isArray(lines) ? lines.length : 1));
    ry += 11 * cnt;
    doc.setFontSize(prevSize);
    doc.setLineHeightFactor(1.1);
  }

  y = boxTop + boxHeight + 20;

  const autoTable = (doc as any).autoTable || autoTableFn;
  if (autoTable) {
    const headers = [['RUTA', 'UNIDAD', 'DETALLE', 'CANT', 'P. UNIT', 'TOTAL']];
    const currency = data.currency === 'USD' ? '$' : 'S/';
    const body = (data.items || []).map((it: any) => [
      it.route || '',
      it.unit || '',
      it.detail || '',
      String(it.qty ?? 0),
      `${currency} ${(it.unitPrice ?? 0).toFixed(2)}`,
      `${currency} ${(((it.qty ?? 0) * (it.unitPrice ?? 0))).toFixed(2)}`,
    ]);

    const runAutoTable = (opts: any) => {
      if (typeof autoTable === 'function' && autoTable.length >= 2) {
        return (autoTable as any)(doc, opts);
      }
      if (typeof (doc as any).autoTable === 'function') {
        return (doc as any).autoTable(opts);
      }
    };

    runAutoTable({
      head: headers,
      body,
      startY: y,
      margin: { left: margin, right: margin },
      tableWidth: pageW - margin * 2,
      styles: { fontSize: 9, cellPadding: 6, overflow: 'linebreak' },
      headStyles: { fillColor: [245, 158, 11], textColor: 255, fontStyle: 'bold', fontSize: 9, cellPadding: 5 },
      columnStyles: {
        0: { cellWidth: 110 },   // RUTA
        1: { cellWidth: 75 },    // UNIDAD
        2: { cellWidth: 160 },   // DETALLE
        3: { cellWidth: 30, halign: 'center' }, // CANT evita salto de "CA\nNT"
        4: { cellWidth: 70, halign: 'right' },  // P. UNIT
        5: { cellWidth: 70, halign: 'right' },  // TOTAL
      }
    });

    const finalY = (doc as any).lastAutoTable.finalY || y;

    // Leyendas de IGV y total
    doc.setFontSize(10); doc.setTextColor(20);
    const importe = (data.items || []).reduce((acc: number, it: any) => acc + (it.qty || 0) * (it.unitPrice || 0), 0);
    const totalLabel = 'IMPORTE';
    const priceStr = `${(data.currency === 'USD' ? '$' : 'S/')} ${importe.toFixed(2)}`;
    doc.text(totalLabel, pageW - margin - 180, finalY + 24);
    doc.text(priceStr, pageW - margin - doc.getTextWidth(priceStr), finalY + 24);
    const legend = data.includeIgv ? 'LOS PRECIOS INCLUYEN IGV' : 'LOS PRECIOS NO INCLUYEN IGV';
    doc.setTextColor(120);
    doc.text(legend, margin, finalY + 24);

    y = finalY + 48;
  }

  // Notas / condiciones (con viñetas y salto de línea)
  if (data.additionalNotes && data.additionalNotes.length) {
    doc.setFontSize(10); doc.setTextColor(40);
    doc.text('CONDICIONES / NOTAS:', margin, y); y += 12;
    doc.setFontSize(9); doc.setTextColor(60);
    const maxW = pageW - margin * 2;
    data.additionalNotes.forEach((n) => {
      const bullet = `• ${n}`;
      const wrapped = doc.splitTextToSize(bullet, maxW);
      doc.text(wrapped, margin, y);
      const lines = Array.isArray(wrapped) ? wrapped.length : 1;
      y += 12 * lines;
    });
    y += 6;
  }

  // Pie de página estilo muestra
  const pageH = doc.internal.pageSize.getHeight();
  doc.setFontSize(10); doc.setTextColor(40); doc.setFont(undefined, 'bolditalic' as any);
  const fact = 'FACTURACIÓN: Se realizará en la fecha que culmine el servicio, a nombre de la empresa cuya razón social aparece en la guía de remisión del transportista';
  doc.text(fact, margin, pageH - 88, { maxWidth: pageW - margin * 2 });
  doc.setFont(undefined, 'normal'); doc.setTextColor(120); doc.setFontSize(9);
  const footerCenter = 'AV. SANTIAGO ANTÚNEZ DE MAYOLO N° 2179 — www.royal-trucking.com — juterrones@royal-trucking.com';
  const centerX = margin + (pageW - margin * 2) / 2 - doc.getTextWidth(footerCenter) / 2;
  doc.text(footerCenter, centerX, pageH - 40);
  const pageText = `Página 1 de 1`;
  doc.text(pageText, pageW - margin - doc.getTextWidth(pageText), pageH - 20);

  doc.save(`cotizacion_${(data.quotationNumber || 'royal').replace(/\s+/g,'_')}.pdf`);
}

